/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import React from 'react';
import { Modal, View, Text } from '@az/starc-ui';

type DynamicModalProps = {
  isOpen: boolean;
  onClose: () => void;
  headerTitle?: string;
  headerColor?: 'primary' | 'secondary';
  hasHeaderBackButton?: boolean;
  hasCloseButton?: boolean;
  hasHeader?: boolean;
  backButtonTitle?: string;
  closeButtonTitle?: string;
  closeByClickAway?: boolean;
  transparent?: boolean;
  id?: string;
  className?: string;
  attributes?: object;
  backdropOpacity?: number;
  backdropClassName?: string;
  backdropAttributes?: object;
  onBackClick?: () => void;
  title?: string;
  description?: string;
  ctaTitle?: string;
  body: React.ReactNode;
};

export default function DynamicModal({
  isOpen,
  onClose,
  headerTitle = '',
  headerColor = 'primary',
  hasHeaderBackButton = false,
  hasCloseButton = false,
  hasHeader = true,
  backButtonTitle = '',
  closeByClickAway = false,
  transparent = false,
  id = '',
  className = '',
  backdropOpacity = 0.8,
  backdropClassName = '',
  onBackClick = () => {},
  title,
  description,
  body,
}: DynamicModalProps) {
  return (
    <Modal
      backButtonTitle={backButtonTitle}
      open={isOpen}
      onClose={onClose}
      hasHeaderBackButton={hasHeaderBackButton}
      hasCloseButton={hasCloseButton}
      closeByClickAway={closeByClickAway}
      transparent={transparent}
      id={id}
      className={className}
      backdropOpacity={backdropOpacity}
      backdropClassName={backdropClassName}
      onBackClick={onBackClick}
      headerTitle={headerTitle}
      headerColor={headerColor}
      size={{ s: 'full', m: 'large', l: 'large' }}
    >
      <View attributes={{ style: { padding: '0 16px 80px' } }}>
        {hasHeader && (
          <Text size="100" weight="bold" lineHeight="125">
            {title}
          </Text>
        )}
        {description && (
          <Text size="087" lineHeight="125">
            {description}
          </Text>
        )}
        {body}
      </View>
    </Modal>
  );
}
